import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ResetPasswordPage from './pages/ResetPassword'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import AxiosInterceptor from './utils/AxiosInterceptor';


const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  // <React.StrictMode>
  <BrowserRouter>
  <Provider store={store}>
    <AuthProvider>
      <AxiosInterceptor />
      <Routes>
          <Route path="/*" element={<App />} />
          <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />
      </Routes>
    </AuthProvider>
    </Provider>
  </BrowserRouter>
// </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
